import React from 'react';
import { PanelRightOpen } from 'lucide-react';

export function QuickViewButton({ onClick, title }) {
    return (
        <button type="button" onClick={onClick} className="inline-flex items-center h-[44px] rounded-[6px] px-3 text-[#003545] hover:bg-[#ededed] cursor-pointer transition-colors" title={title} aria-label={title}>
            <PanelRightOpen className="size-4" />
        </button>
    );
}
